import { PopupsApi } from 'api';
import { useClickStreamContext } from 'features/shared/ClickStream';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
const popupId = 75;
const PdfViewPage = () => {
  const params = useParams<{ subject_id: string }>();
  const context = useClickStreamContext();

  useEffect(() => {
    const subject_id = params.subject_id && !isNaN(+params.subject_id) ? +params.subject_id : -1;
    context.logPageEvent?.({
      eventType: `show_${popupId}_popup`,
      eventInfo: `${popupId}: Показан попапа`,
      eventSource: 'municipality',
    });
    PopupsApi.loggedShowPopup(popupId, { subjectId: subject_id });
  }, []);
  return (
    <iframe
      src="https://upr.uchi.ru/files/47875f596241f036/Как эффективно начать учебный год.pdf"
      style={{ width: '100vw', height: '100vh' }}
    />
  );
};

export default PdfViewPage;
